<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><a id="page5"></a>Vultures</p>
<p class="number">1</p>
<p class="noindent">A product can be authentic;</p>
<p class="noindents">an object cannot.</p>
<p class="noindent">This presents a problem.</p>
<p class="noindent">An identity can be authentic;</p>
<p class="noindents">an experience cannot.</p>
<p class="noindent">“How was your sleep experience,”</p>
<p class="noindents">asks Marriott.</p>
<p class="noindent">Praise or blame</p>
<p class="noindents">is the only legitimate response.</p>
<p class="number">2</p>
<p class="noindent">Vultures wheel over Miami.</p>
<p class="noindent">A sign that appears</p>
<p class="noindents">day after day</p>
<p class="noindents">is not a sign.</p>
<p class="noindent">The library boasts a fine collection</p>
<p class="noindents">of books written in private</p>
<p class="noindents">languages.</p>
<p class="number">3</p>
<p class="noindent">Identity is made</p>
<p class="noindents">of select experiences.</p>
<p class="number"><a id="page6"></a>4</p>
<p class="noindent">When you are genuinely sick,</p>
<p class="noindents">the leaves recede</p>
<p class="noindent">and the flickering holes between them</p>
<p class="noindents">come forward—</p>
<p class="noindent">not angels, but</p>
<p class="noindents">unnamed objects</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010_Chapter003.vue?cee85712